import React, {Component } from 'react';
import { Breadcrumb, Card,Divider,Button,DatePicker   } from 'antd';
import { DashboardOutlined, FilePdfOutlined,SendOutlined} from '@ant-design/icons';
import {Row, Col} from 'react-bootstrap';

const { Meta } = Card;

class FakturPajakDownload extends Component {
    render(){
        return (
            <div >
                <Breadcrumb>
                    <Breadcrumb.Item><DashboardOutlined /> BAR & Download</Breadcrumb.Item>
                </Breadcrumb>
                <Row>
                    <Col sm={12}  lg={12} style={{marginBottom:20}}>
                        <Card bordered={false} className="box">
                            <Row>
                                <Col sm={10}  lg={10} style={{textAlign:"right"}}>
                                    Periode  Transaksi
                                </Col>
                                <Col sm={1}  lg={1} style={{textAlign:"right"}}>
                                    <DatePicker  picker="month"  />  
                                </Col>
                                <Col sm={1}  lg={1} style={{textAlign:"right"}}>
                                    <Button type="primary" icon={<SendOutlined />} >
                                        Process
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col sm={3}  lg={3} style={{marginBottom:20}}>
                        <Card bordered={false} className="box" style={{textAlign:"left"}}>
                            <Divider orientation="left">FAKTUR PAJAK PERIODE 2020-10</Divider>
                            <Row>
                                <Col sm={12}  lg={12} style={{marginBottom:10}}>
                                    <Card >
                                        <Meta
                                            avatar={
                                                <FilePdfOutlined />
                                            }
                                            title="FAKTUR PAJAK"
                                            description="Nomor : 010.901-2020.1"
                                        />
                                    </Card>
                                </Col>
                                
                            </Row>
                        </Card>
                    </Col>
                    <Col sm={3}  lg={3} style={{marginBottom:20}}>
                        <Card bordered={false} className="box" style={{textAlign:"left"}}>
                            <Divider orientation="left">FAKTUR PAJAK PERIODE 2020-09</Divider>
                            <Row>
                                <Col sm={12}  lg={12} style={{marginBottom:10}}>
                                    <Card >
                                        <Meta
                                            avatar={
                                                <FilePdfOutlined />
                                            }
                                            title="FAKTUR PAJAK"
                                            description="Nomor : 010.901-2020.1"
                                        />
                                    </Card>
                                </Col>
                                
                            </Row>
                        </Card>
                    </Col>
                    <Col sm={3}  lg={3} style={{marginBottom:20}}>
                        <Card bordered={false} className="box" style={{textAlign:"left"}}>
                            <Divider orientation="left">FAKTUR PAJAK PERIODE 2020-08</Divider>
                            <Row>
                                <Col sm={12}  lg={12} style={{marginBottom:10}}>
                                    <Card >
                                        <Meta
                                            avatar={
                                                <FilePdfOutlined />
                                            }
                                            title="FAKTUR PAJAK"
                                            description="Nomor : 010.901-2020.1"
                                        />
                                    </Card>
                                </Col>
                                
                            </Row>
                        </Card>
                    </Col>
                    <Col sm={3}  lg={3} style={{marginBottom:20}}>
                        <Card bordered={false} className="box" style={{textAlign:"left"}}>
                            <Divider orientation="left">FAKTUR PAJAK PERIODE 2020-07</Divider>
                            <Row>
                                <Col sm={12}  lg={12} style={{marginBottom:10}}>
                                    <Card >
                                        <Meta
                                            avatar={
                                                <FilePdfOutlined />
                                            }
                                            title="FAKTUR PAJAK"
                                            description="Nomor : 010.901-2020.1"
                                        />
                                    </Card>
                                </Col>
                                
                            </Row>
                        </Card>
                    </Col>

                    
                </Row>
            </div>
        )
    }
}


export default FakturPajakDownload;
